import React, { useEffect, useRef } from "react";

// Make sure you have included the Auspice CSS/JS in index.html:
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/auspice@latest/dist/auspice.min.css">
// <script src="https://cdn.jsdelivr.net/npm/auspice@latest/dist/auspice.min.js"></script>

export default function AuspiceViewer({ jsonUrl }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!jsonUrl || !containerRef.current) return;

    if (window.auspice) {
      window.auspice.load({
        url: jsonUrl,
        el: containerRef.current,
      });
    }
  }, [jsonUrl]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "800px",
        border: "1px solid #ddd",
        borderRadius: "6px",
        backgroundColor: "#fff",
      }}
    ></div>
  );
}
